import { configureStore } from '@reduxjs/toolkit';
import questionListReducer from '../features/questionsListSlice';
import deleteQuestionReducer from '../features/deleteQuestoinSlice';
import getSingleQuestionReducer from '../features/getSingleQuestionSlice';

export const store = configureStore({
  reducer: {
    questionList: questionListReducer,
    singleQuestionList: getSingleQuestionReducer,
    deleteQuestion: deleteQuestionReducer,
  },
});
